import { render } from "./SampleBookView.vue?vue&type=template&id=5100dc6c&scoped=true&ts=true"
import script from "./SampleBookView.vue?vue&type=script&lang=ts"
export * from "./SampleBookView.vue?vue&type=script&lang=ts"

import "./SampleBookView.vue?vue&type=style&index=0&id=5100dc6c&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5100dc6c"]])

export default __exports__